import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import VerticalSlider from '~/components/Sliders/VerticalSlider';
import { ImageViewMode } from '~/engine/core/render/renderers/ImageRenderer';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import {
    checkerboardDensityState,
    imageSecondaryAmountState,
    selectedSecondaryImageModeState,
} from '~/state/atoms/image/imageAtoms';

export default function ImageBlendSlider() {
    const intl = useIntl();
    const { updateCheckerboardDensity, updatePrimaryImageAlpha } =
        useViewportEnvironment();
    const selectedViewMode = useRecoilValue(selectedSecondaryImageModeState);
    const [imageSecondaryAmount, setImageSecondaryAmount] = useRecoilState(
        imageSecondaryAmountState
    );
    const [checkerboardDensity, setCheckerboardDensity] = useRecoilState(
        checkerboardDensityState
    );

    const handleAlphaChange = (_: Event, newValue: number | number[]) => {
        const value = newValue as number;
        setImageSecondaryAmount(value);
        updatePrimaryImageAlpha(value);
    };

    const handleCheckerboardChange = (
        _: Event,
        newValue: number | number[]
    ) => {
        const value = newValue as number;
        setCheckerboardDensity(value);
        updateCheckerboardDensity(value);
    };

    return (
        <>
            {selectedViewMode === ImageViewMode.AlphaBlending && (
                <VerticalSlider
                    key="alphaBlending"
                    value={imageSecondaryAmount}
                    onChange={handleAlphaChange}
                    min={0}
                    max={100}
                    valueLabelFormatter={(v) => `${v}%`}
                    aria-label={intl.formatMessage({ id: 'alphaBlending' })}
                />
            )}

            {selectedViewMode === ImageViewMode.Checkerboard && (
                <VerticalSlider
                    key="checkerboard"
                    value={checkerboardDensity}
                    onChange={handleCheckerboardChange}
                    min={0.1}
                    max={1}
                    step={0.1}
                    valueLabelFormatter={(v) => `${v * 100}%`}
                    aria-label={intl.formatMessage({
                        id: 'checkerboardDensity',
                    })}
                />
            )}
        </>
    );
}
